import React, { useMemo } from 'react';
import { useAppContext } from '../../context/AppContext';
import DataTable from '../DataTable';
import { t } from '../../i18n';

const columns = [
  {
    key: 'name',
    label: 'Nombre',
    sortable: true,
    render: (value) => <span className="font-semibold text-slate-800">{t(value)}</span>
  },
  { key: 'role', label: 'Rol', sortable: true },
  { key: 'contact', label: 'Contacto', sortable: true }
];

const DevelopmentTeam = () => {
  const { renewablePortfolio, users } = useAppContext();

  const team = useMemo(() => {
    const ids = new Set();
    renewablePortfolio.forEach((project) => {
      if (project.responsibleId) ids.add(project.responsibleId);
    });
    return users
      .filter((user) => ids.has(user.id))
      .map((user) => ({
        id: user.id,
        name: user.name,
        role: user.role,
        contact: user.email
      }));
  }, [renewablePortfolio, users]);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-slate-900">{t('Equipo de Desarrollo')}</h1>
        <p className="text-sm text-slate-500">{t('Personas, roles y contactos asociados a proyectos renovables.')}</p>
      </div>

      <DataTable
        data={team}
        columns={columns}
        searchPlaceholder={t('Buscar integrante...')}
        emptyTitle={t('Sin integrantes')}
        emptyDescription={t('No hay responsables asignados a proyectos renovables.')}
      />
    </div>
  );
};

export default DevelopmentTeam;
